'use client';

import { Accordion } from '@mv/web-ui';
import { useDataTags } from '@/modules/tracking/analytics/useDataTags';
import { assertPayloadType } from '@/modules/utils/assert';
import RichText, { type RichTextOptions } from '@/payload/components/RichText/RichText';
import ThemedIconImg from '@/payload/components/ThemedIcon/ThemedIcon';
import type { CollapseItem as CollapseItemType, ThemedIcon as ThemedIconType } from '@/payload/types';

interface CollapseItemProps {
	value: string;
	item: CollapseItemType;
	options: RichTextOptions;
}

export function CollapseItem({ value, item, options, ...restProps }: CollapseItemProps) {
	const { blockRef, labelRef, contentRef } = useDataTags('collapseItem', value);

	return (
		<Accordion.Item value={value} ref={blockRef} {...restProps}>
			<Accordion.Trigger as="h3" icon={item.icon && <CollapseItemIcon item={item} />} ref={labelRef}>
				{item.header}
			</Accordion.Trigger>
			<Accordion.Content ref={contentRef}>
				<RichText content={item.richText} options={options} />
			</Accordion.Content>
		</Accordion.Item>
	);
}

type CollapseItemIconProps = {
	item: CollapseItemType;
};

function CollapseItemIcon({ item }: CollapseItemIconProps) {
	if (!item.icon) return undefined;

	assertPayloadType<ThemedIconType>(item.icon);

	return <ThemedIconImg icon={item.icon} size={item.iconSize} />;
}
